import React from "react";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import {
  fetchLicenseAgreement,
  updateLicenseAgreement,
} from "./licensing_redux";
import { sendMessage } from "../../Pages/Chat/ChatRedux";
import Message from "../../Pages/Chat/ChatComponents/Message";
import LicenseAgreementRequested from "./licensing_components/_license_agreement_requested";
import LicenseAgreementAccepted from "./licensing_components/_license_agreement_accepted";
import LicenseAgreementPurchased from "./licensing_components/_license_agreement_purchased";
import Loader from "../../Shared/Loader";

class LicenseRequest extends React.Component {
  state = {
    downloadLink: "",
    termsAccepted: false,
    agreement: null,
  };

  componentWillMount() {
    const {
      dispatch,
      meta: { license_agreement },
    } = this.props;
    dispatch(fetchLicenseAgreement(license_agreement));
  }

  componentDidUpdate({ meta, licenseAgreements }) {
    const agreement = licenseAgreements.find(
      ({ license_agreement }) =>
        license_agreement._id === meta.license_agreement
    );
    if (!isEqual(this.state.agreement, agreement)) {
      this.setState({ agreement });
    }
  }

  componentDidUpdate(prevProps) {
    //If License status update runtime
    const { dispatch, meta } = this.props;
    if (prevProps.meta.license_agreement !== meta.license_agreement) {
      dispatch(fetchLicenseAgreement(meta.license_agreement));
    }
  }

  acceptAgreement = (data) => {
    const { dispatch } = this.props;
    const {
      agreement: {
        license_agreement: { _id, requester_id },
      },
    } = this.state;
    dispatch(sendMessage(requester_id));
    if (data.decline) {
      dispatch(updateLicenseAgreement(_id, data));
    } else {
      const meta = { license_agreement: _id, accepted: true };
      this.sendMessageAndUpdateAgreement(_id, data, meta);
    }
  };

  purchaseLicense = (data) => {
    const {
      agreement: {
        license_agreement: { _id, influencer_id },
      },
    } = this.state;
    this.props.dispatch(sendMessage(influencer_id));
    const meta = { license_agreement: _id, purchased: true };
    this.sendMessageAndUpdateAgreement(_id, data, meta);
  };

  sendMessageAndUpdateAgreement = (id, data, meta) => {
    const {
      dispatch,
      channel,
      currentUser: { _id, first_name, last_name },
    } = this.props;
    const { pubnub } = window;
    pubnub.publish({
      channel,
      message: {
        message: "",
        publisher: "vyrill",
        meta,
      },
    });
    pubnub.publish({
      channel: "vyrill",
      message: {
        channel,
        user: [first_name, last_name].join(" "),
        user_id: _id,
      },
      storeInHistory: false,
    });
    dispatch(updateLicenseAgreement(id, data));
  };

  render() {
    const {
      meta,
      message,
      isSender,
      user,
      currentUser,
      influencer,
      timetoken,
      image,
    } = this.props;
    const { agreement } = this.state;
    const { first_name, last_name } = currentUser;

    if (!agreement) {
      return (
        <Message
          isOwnMessage={isSender}
          timetoken={timetoken}
          first_name={first_name}
          last_name={last_name}
        >
          <Loader />
        </Message>
      );
    }
    const {
      license_agreement: {
        accepted_at,
        declined_at,
        requester_id,
        influencer_royalties,
      },
      license_video: { title: video_title },
    } = agreement;

    if (meta.purchased) {
      return (
        <Message isVyrillMessage timetoken={timetoken}>
          <LicenseAgreementPurchased
            influencer={influencer}
            user={user}
            isPurchaser={requester_id === currentUser._id}
            video_title={video_title}
            royalties={influencer_royalties}
          />
        </Message>
      );
    }

    if (meta.accepted && requester_id === currentUser._id) {
      return (
        <Message isVyrillMessage timetoken={timetoken}>
          <LicenseAgreementAccepted
            user={user}
            agreement={agreement}
            purchaseLicense={this.purchaseLicense}
          />
        </Message>
      );
    }

    const status = accepted_at
      ? "ACCEPTED"
      : declined_at
      ? "DECLINED"
      : "PENDING";
    return (
      <Message
        isOwnMessage={isSender}
        timetoken={timetoken}
        image={image}
        first_name={first_name}
        last_name={last_name}
      >
        <LicenseAgreementRequested
          message={message}
          agreement={agreement}
          status={status}
          isRequester={requester_id === currentUser._id}
          user={user}
          acceptAgreement={this.acceptAgreement}
        />
      </Message>
    );
  }
}

const mapStateToProps = ({
  licenseAgreements,
  navbarStatsReducer: { current_user },
}) => ({
  licenseAgreements,
  currentUser: current_user,
});

export default connect(mapStateToProps)(LicenseRequest);
